/**
 * 1: Wet Lab
 * 2: Dry Lab
 * 3: Sci Comm
 * 4: Advisors
 * 5: Investigators
 */

export const TeamList = [
    {
        dept: 1,
        name: 'Chris Vicera',
        role: 'Leader & Lab Researcher',
        major: 'Molecular Biology & Biotechnology',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/wet-lab-chris.png',
    },
    {
        dept: 1,
        name: 'Tanvi Falodiya',
        role: 'Lab Researcher',
        major: 'Biomedical Science, minor in Genetics and Genomics',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/wet-lab-tanvi.png',
    },
    {
        dept: 1,
        name: 'Louis Yu',
        role: 'Lab Researcher & Hardware Engineer',
        major: 'Molecular Biology & Biotechnology',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/wet-lab-louis.png',
    },
    {
        dept: 1,
        name: 'Sneha Balasubramanian',
        role: 'Lab Researcher',
        major: 'Biomedical Science',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/wet-lab-sneha.png',
    },
    {
        dept: 1,
        name: 'Eugenia Fong',
        role: 'Lab Researcher',
        major: 'Molecular Biology & Biotechnology',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/wet-lab-eugenia.png',
    },
    {
        dept: 2,
        name: 'Jegadish A. Natarajan',
        role: 'Modelling',
        major: 'Molecular Biology & Biotechnology (Intensive)',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/dry-lab-jegadish.png',
    },
    {
        dept: 2,
        name: 'Clara Pun',
        role: '#Code Monkey',
        major: 'Molecular Biology & Biotechnology, Computer Science',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/dry-lab-clara-new.jpg',
    },
    {
        dept: 2,
        name: 'Angel Ng',
        role: 'Hardware Engineer',
        major: 'Biomedical Engineering',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/dry-lab-angel.png',
    },
    {
        dept: 2,
        name: 'Sathya G. Balaji',
        role: 'Hardware Engineer',
        major: 'Applied AI',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/dry-lab-sathya.png',
    },
    {
        dept: 3,
        name: 'Rita Lim',
        role: 'Team Leader & Media',
        major: 'Molecular Biology & Biotechnology, minor in Finance',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/scicomm-rita.png',
    },
    {
        dept: 3,
        name: 'Kirndeep Kaur',
        role: 'Communications',
        major: 'Biological Science, minor in Food & Nutrition',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/sciomm-kiran.png',
    },
    {
        dept: 3,
        name: 'Vismaya R. Pillai',
        role: 'Media & Modelling advisor',
        major: 'Physics, minor in Computer Science',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/scicomm-vismaya.png',
    },
    {
        dept: 3,
        name: 'Sarah Khan',
        role: 'Communications',
        major: 'Molecular Biology & Biotechnology, Criminology, minor in Marketing',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/scicomm-sarah.png',
    },
    {
        dept: 3,
        name: 'Faye Long',
        role: 'Finance & Entrepreneurship officer',
        major: 'Molecular Biology & Biotechnology, minor in Science Entrepreneurship',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/scicomm-feifei.png',
    },
    {
        dept: 3,
        name: 'K. Sunanas Utsha',
        role: 'Communications',
        major: 'Double Degree in Biological Science & Education (Science)',
        icon: 'https://static.igem.wiki/teams/4241/wiki/team/scicomm-sunanas.png',
    },
]